import { connect } from '../../_redux'

import Toast from './Toast.component'

export default connect(state => ({
  menuOpen: state.app.openMenu,
}))(Toast)
